import { IconBilling } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentBilling';
const links = [
  { title: 'Invoices', href: '/billing/invoices' },
  { title: "CDR's", href: '/reports/cdrs' },
  {
    title: 'Balance/Top-up',
    href: '/billing/balance',
    onlyPrepaid: true,
  },
];
const billingSubNav = () =>
  subNav({
    id: navId,
    title: 'Billing',
    href: '/billing',
    icon: IconBilling,
    links,
  });
export default billingSubNav;
